module.exports = __webpack_public_path__ + "static/media/KM_user_manual.b23bd068.pdf";